import { createContext } from 'react';

const ApplicationContext = createContext({
  scrollto: () => {}
});

export default ApplicationContext;


// WEBPACK FOOTER //
// ./src/ApplicationContext.js